<template>
  <div class="product">
    <div class="thankyou">
      {{ $t('thankyou') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Thankyou',
}
</script>

<style>
.thankyou {
  font-size: 20px;
  font-weight: 900;
  color: seagreen;
}
</style>
